/*
 * @Author: tianzhitong laotianwy@163.com
 * @Date: 2024-04-23 23:20:40
 * @LastEditors: tianzhitong laotianwy@163.com
 * @LastEditTime: 2024-04-23 23:25:50
 * @FilePath: /seller-station-client/src/hooks/useGetRate.ts
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { useAtomValue, useSetAtom } from 'jotai';
import { useAsyncEffect } from 'ahooks';
import { isLogin, systemUserRate } from '@/atom/mall/user';
import { rateInfo } from '@/atom/rate';

/** 获取系统汇率 */
export const useGetSystemRate = () => {
	const currentUserIsLogin = useAtomValue(isLogin);
	const setSystemUserRate = useSetAtom(systemUserRate);
	const { floatingRate } = rateInfo();
	useAsyncEffect(async () => {
		setSystemUserRate(floatingRate);
	}, [currentUserIsLogin, setSystemUserRate]);
};
